var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SlideInTransitionTop',[(_vm.animated || !_vm.animateIn)?_c('mp-link',{staticClass:"flex items-center justify-center px-6 py-2 text-sm leading-none tracking-wider uppercase transition-all border border-solid cursor-pointer min-w-fit rounded-3xl lg:px-8 lg:py-3 hover:border-black",class:{
      'border-black': _vm.isActive,
      'border-gray': !_vm.isActive,
      'scale-105': _vm.clickAnimationActive,
    },attrs:{"to":_vm.$u(_vm.link)}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }